<script>
 import CeviriFormu from './CeviriFormu.svelte'
 import CumleFormu from './CumleFormu.svelte'

 import {çeviriyiGöster}  from './kasa.js'
 import {cümleyiGöster}  from './kasa.js'
 import {cümleÇevirileriniGöster}  from './kasa.js'

 function çeviriEkle()
 {
     $çeviriyiGöster = !$çeviriyiGöster
     $cümleyiGöster = false
     $cümleÇevirileriniGöster = false;

     if ($çeviriyiGöster === false && $cümleyiGöster === false)
     {
         $cümleÇevirileriniGöster = true;
     }
 }

 function cümleEkle()
 {
     $cümleyiGöster = !$cümleyiGöster
     $çeviriyiGöster = false
     $cümleÇevirileriniGöster = false;

     if ($çeviriyiGöster === false && $cümleyiGöster === false)
     {
         $cümleÇevirileriniGöster = true;
     }
 }

</script>

<div id="eklemebölümü">
  <a id="çeviriEkle" href="/" on:click|preventDefault="{çeviriEkle}">Çevir</a>
  <a id="cumleEkle" href="/cumle/ekle" on:click|preventDefault="{cümleEkle}">Cümle ekle</a>
  <a id="oynat" href="/">Oynat</a>
  <a id="hikaye" href="/">Hikaye</a>
  <br>
  <a id="kelimeSeç" href="/">Kelime seç</a>
  <a id="seçimiKaldır" href="/">Seçimi kaldır</a>
  <a id="kelimeEkle" href="/">Kelimeleri ekle</a>

  <!-- çeviri formu -->
  {#if $çeviriyiGöster}
    <CeviriFormu />
  {/if}

  <!-- cumle formu -->
  {#if $cümleyiGöster}
    <CumleFormu />
  {/if}


</div>
